import React from "react";
import { Link } from "react-router-dom";

const fmt = (iso) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" }) : "—";
const fmtTime = (iso) =>
  iso ? new Date(iso).toLocaleString(undefined, { weekday: "short", hour: "numeric", minute: "2-digit" }) : "";

export const CoachingStatusCard = ({ status }) => {
  if (!status) return null;
  const rows = [
    status.owns_program && { k: "Purchased", v: fmt(status.purchased_at), id: "status-purchased" },
    status.owns_program && {
      k: status.coaching_active ? "Coaching ends" : "Coaching ended",
      v: fmt(status.coaching_expires_at),
      id: "status-expires",
    },
    { k: "Daily allowance", v: `${status.daily_limit} messages`, id: "status-allowance" },
    { k: "Left today", v: `${status.remaining_today} of ${status.daily_limit}`, id: "status-remaining" },
  ].filter(Boolean);

  return (
    <div className="bg-white rounded-3xl p-6 border border-[#2A3B32]/10 shadow-[0_8px_30px_rgba(42,59,50,0.04)]" data-testid="coaching-status-card">
      <div className="flex items-center justify-between gap-3">
        <div className="eyebrow text-[#5C6A61]">your coaching</div>
        <span
          data-testid="status-plan"
          className={`text-xs px-3 py-1 rounded-full ${status.coaching_active ? "bg-[#81B29A]/20 text-[#2A3B32]" : "bg-[#F2EBE5] text-[#5C6A61]"}`}
        >
          {status.coaching_active ? "Discipline Reset" : status.owns_program ? "Reset complete · Free plan" : "Free plan"}
        </span>
      </div>
      <dl className="mt-4 space-y-2">
        {rows.map((r) => (
          <div key={r.k} className="flex justify-between gap-4 text-sm">
            <dt className="text-[#5C6A61]">{r.k}</dt>
            <dd className="text-[#1C221D] font-medium" data-testid={r.id}>{r.v}</dd>
          </div>
        ))}
      </dl>
      <div className="mt-4 h-1.5 rounded-full bg-[#F2EBE5] overflow-hidden">
        <div className="h-full bg-[#E07A5F]" style={{ width: `${(status.used_today / status.daily_limit) * 100}%` }} />
      </div>
      <div className="text-xs text-[#5C6A61] mt-2">Messages refresh {fmtTime(status.resets_at)}</div>
      {!status.owns_program && (
        <Link to="/program" data-testid="status-upgrade-link" className="mt-4 inline-block text-sm text-[#E07A5F] underline underline-offset-4">
          Get {status.paid_daily_limit} a day with the Discipline Reset
        </Link>
      )}
    </div>
  );
};

export default CoachingStatusCard;
